


















































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IActivityStatus } from "@/@types/admin/activity-status";
@Component({})
export default class TvSettings extends Vue {
  @Prop({ type: Object, default: null }) user!: IActivityStatus;

  get getInstantPower(): string {
    if (!this.user || !this.user.property) return "-";
    switch (this.user.property.instant_power) {
      case "0":
        return "0: off";
      case "1":
        return "1: on reboot";
      case "2":
        return "2: on mute";
      default:
        return `unknown: ${this.user.property.instant_power}`;
    }
  }

  get getBootSequenceOption(): string {
    if (!this.user || !this.user.property) return "-";
    switch (this.user.property.boot_sequence_option) {
      case "0":
        return "0: AV Show + P:C App Show";
      case "1":
        return "1: Pro:Centric App Show Only";
      default:
        return `unknown: ${this.user.property.boot_sequence_option}`;
    }
  }

  get getApplicationChannelControl(): string {
    if (!this.user || !this.user.property) return "-";
    switch (this.user.property.application_channel_control) {
      case "0":
        return "0 : Both TV and HCAP Application can change the channel. TV changes the channel for channel-related keys (Channel Up/Down, Numeric, TV/RAD, etc). HCAP Application changes the channel by channel.requestChangeCurrentChannel().";
      case "1":
        return "1 : TV channel can be changed only by channel.requestChangeCurrentChannel().";
      default:
        return `unknown: ${this.user.property.application_channel_control}`;
    }
  }
}
